var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('app-input',{staticClass:"margin-top-5",attrs:{"type":"switch"},on:{"change":_vm.triggerIsDefault},model:{value:(_vm.item),callback:function ($$v) {_vm.item=$$v},expression:"item"}}),_vm._v(" "),_c('span',{staticClass:"ml-1 mt-1"},[_vm._v(_vm._s(_vm.item === 1 ? _vm.$t('yes') : _vm.$t('no')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }